/**
 * ApiService rethrows only the response body of a failed request, so callers
 * lose the HTTP status. It is recorded here, keyed by the thrown body, so a
 * caller that needs it can read it without changing what is thrown.
 * Text bodies carry no status. An empty (null) body is replaced by an object
 * in ApiService, so it does.
 */
const httpStatusByError = new WeakMap<object, number>();

export function apiErrorHttpStatusSet(error: unknown, status: number): void {
  if (typeof error === "object" && error !== null) {
    httpStatusByError.set(error, status);
  }
}

export function apiErrorHttpStatus(error: unknown): number | undefined {
  return typeof error === "object" && error !== null
    ? httpStatusByError.get(error)
    : undefined;
}
